import axios from '@/helpers/axios'

/**
 * 充电费率 的API调用。详细参数参考: /backend/v2/apidoc
 */
export default {
  /**
   * 获取系统信息
   *
   * @returns {Promise<object>} 格式 { total_count: 0, ... }
   *
   */
  getInfo() {
    return axios.get(`/backend/system/info`)
  }
}
